var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29804 3.64326L9.80782 3.13348C10.6525 2.28884 12.0219 2.28884 12.8665 3.13348C13.7112 3.97812 13.7112 5.34754 12.8665 6.19218L12.3567 6.70196M9.29804 3.64326C9.29804 3.64326 9.36176 4.72655 10.3176 5.6824C11.2734 6.63824 12.3567 6.70196 12.3567 6.70196M9.29804 3.64326L4.61135 8.32994C4.29391 8.64738 4.13519 8.8061 3.99869 8.98111C3.83767 9.18755 3.69962 9.41092 3.58699 9.64726C3.4915 9.84762 3.42052 10.0606 3.27856 10.4865L2.82404 11.85L2.67699 12.2911M12.3567 6.70196L7.67006 11.3886C7.35262 11.7061 7.1939 11.8648 7.01889 12.0013C6.81245 12.1623 6.58908 12.3004 6.35274 12.413C6.15238 12.5085 5.93944 12.5795 5.51355 12.7214L4.15 13.176L3.70886 13.323M3.70886 13.323L3.26771 13.4701C3.05813 13.5399 2.82706 13.4854 2.67085 13.3292C2.51463 13.1729 2.46009 12.9419 2.52995 12.7323L2.67699 12.2911M3.70886 13.323L2.67699 12.2911",
    stroke: "currentColor",
    strokeWidth: 0.825
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit1.3353a6f4d365418e8b30e0a50f30e156.svg";
export { ForwardRef as ReactComponent };